import React from 'react'

import { WORKLIFE_SERVICE_IDS } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/workLifeConstants'
import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import { getCarelonDefaultWorkLifeServices } from './default'
import { WorkLifeIconFinancial } from '../atoms/icons/WorkLifeIcons'

export const skadden: GetCustomerCopyFunc = () => {
  const CARELON_WORKLIFE_SERVICES = getCarelonDefaultWorkLifeServices('skadden')
  return {
    workLifeServices: [
      CARELON_WORKLIFE_SERVICES.LEGAL_SERVICES,
      {
        identifiers: WORKLIFE_SERVICE_IDS.FINANCIAL_SERVICES,
        title: 'MSA Financial Coaching',
        iconSvg: <WorkLifeIconFinancial size={48} />,
        paragraph: '',
        bullets: [
          'One-on-one phone-based financial coaching and digital tools via MSA',
          'Support with Budgeting, Investment Guidance, Tax Planning, and more...',
        ],
        CTA: 'Access financial support ',
        PATH: 'http://msamembers.net/launch/aa4601e0-990e-11ed-9f42-c8c4f5ad2957',
      },
      CARELON_WORKLIFE_SERVICES.IDENTITY_THEFT,
      CARELON_WORKLIFE_SERVICES.DEPENDENT_CARE,
    ],
  }
}
